import React from 'react';
import { MonitorIcon, MoonIcon, SunIcon, type LucideIcon } from 'lucide-react';
import { useTheme } from '../../hooks';
import type { ThemePreference } from '../../theme/initScript';

const THEME_CHOICES: { value: ThemePreference; label: string; Icon: LucideIcon }[] = [
  { value: 'light', label: 'Light', Icon: SunIcon },
  { value: 'dark', label: 'Dark', Icon: MoonIcon },
  { value: 'system', label: 'System', Icon: MonitorIcon },
];

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const current = THEME_CHOICES.find(option => option.value === theme) ?? THEME_CHOICES[2];

  const closeMenu = () => (document.activeElement as HTMLElement)?.blur();

  return (
    <div className="dropdown dropdown-end">
      <div tabIndex={0} role="button" className="btn btn-ghost btn-circle" aria-label={`Theme (current: ${current.label})`}>
        <current.Icon className="size-5" />
      </div>
      <ul tabIndex={-1} className="menu menu-sm dropdown-content bg-base-100 border border-base-300 rounded-box z-1 mt-2 w-36 p-2">
        {THEME_CHOICES.map(({ value, label, Icon }) => (
          <li key={value}>
            <button
              type="button"
              aria-pressed={value === theme}
              className={value === theme ? 'menu-active' : ''}
              onClick={() => {
                closeMenu();
                setTheme(value);
              }}
            >
              <Icon className="size-4" />
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
